
import { loginData, token, userInfo, authList } from '@/utils/cookies'

const user = {
  state: {
    token: token.get(),
    userInfo: userInfo.get(),
    authList: authList.get()
  },

  mutations: {
    SET_LOGIN_DATA: (state, data) => {
      let {token, userInfo, authList} = data;
      state.token = token;
      state.userInfo = userInfo;
      state.authList = Array.isArray(authList) 
      ? authList 
      : typeof authList === 'string' 
      ? authList.split(',') 
      : [];
      loginData.set(data);
    },
    LOGOUT: state => {
      state.token = null;
      state.userInfo = null;
      state.authList = null;
      loginData.del();
    }
  },

  actions: {
    SetLoginData: ({ commit }, data) => {
      commit('SET_LOGIN_DATA', data);
    },
    LogOut: ({ commit }) => {
      commit('LOGOUT');
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js